import React from "react";
import { connect } from "react-redux";

import FlatButton from "material-ui/FlatButton";
import TextField from "material-ui/TextField";
import Dialog from "material-ui/Dialog";
import Spinner from "../../components/spiner/Spinner";
import TemplateUploader from './TemplateUploader';
import * as templatesSelectors from "../../redux/templates/selectors";

const mapStateToProps = state => ({
  isChanged: templatesSelectors.isChanged(state)
});

const LIMIT = 100;

class TemplateCreator extends React.Component {
  state = {
    nameTemplate: "",
    isOpen: false,
    titleText: "",
    typeReport: "project"
  };

  onChanger = name => e => this.setState({ [name]: e.target.value });
  onTypeReport = this.onChanger("typeReport");
  onText = this.onChanger("nameTemplate");

  onTitleText = e => {
    if (this.lengthChecker(e.target.value)) return;
    this.setState({ titleText: e.target.value });
  };

    lengthChecker = str => str.length > LIMIT;
    haveError = str => str.length > LIMIT - 1;

  onAdd = () => {
    const { onAdd } = this.props;
    const { nameTemplate, titleText, typeReport } = this.state;
    onAdd({ title: nameTemplate, titleText, typeReport });
    this.onClose();
  };
  onClose = () => {
    this.props.onClose();
    this.setState({ isOpen: false, nameTemplate: "" });
  };

  onEdit = () => {
    const { onEdit } = this.props;
    const { nameTemplate } = this.state;
    onEdit({ title: nameTemplate });
    this.onClose();
  };

  componentWillReceiveProps({ activeItem }) {
    if (activeItem) {
      this.setState({ nameTemplate: activeItem.title });
    }
  }

  render() {
    const { nameTemplate, isOpen, typeReport, titleText } = this.state;
    const { activeItem, isChanged, types } = this.props;
    const onConfirm = !!activeItem ? this.onEdit : this.onAdd;
    const title = !!activeItem ? "Done" : "Add";
    const titleHaveError = this.haveError(titleText) ? 'max length 100 symbols' : '';
    return (
      <React.Fragment>
        {isChanged && (
          <div
            style={{
              position: "fixed",
              top: 22,
              right: 300,
              zIndex: 1300
            }}
          >
            <Spinner />
          </div>
        )}
        <Dialog
          onClose={this.onClose}
          open={isOpen || !!activeItem}
          autoDetectWindowHeight
        >
          <div style={{ textAlign: "center" }}>Template</div>
          <div>
            <TextField
              underlineFocusStyle={{ borderColor: "#6da92e" }}
              fullWidth
              id="text"
              type="text"
              onChange={this.onText}
              value={nameTemplate}
              placeholder="Add Template Name"
            />
            <div className="template-creator-info">
              This is the name you will see when you select which template to
              use
            </div>
          </div>
          {!activeItem && (
            <React.Fragment>
              <div>
                <TextField
                  underlineFocusStyle={{ borderColor: "#6da92e" }}
                  fullWidth
                  id="text"
                  type="text"
                  onChange={this.onTitleText}
                  value={titleText}
                  placeholder="Add Report Title"
                  errorText={titleHaveError}
                />
                <div className="template-creator-info">
                  This is the title you we see as PDF title when you print the
                  report
                </div>

              </div>
              <div>
                <div className="checklist-select">
                  <select
                    className="select-text template-select-text"
                    value={typeReport}
                    onChange={this.onTypeReport}
                  >
                    {types.map(category => (
                      <option key={category.value} value={category.value}>
                        {category.label}
                      </option>
                    ))}
                  </select>
                  <span className="select-highlight" />
                  <span className="select-bar" />
                  {/*<label className="select-label template-select-label">Format</label>*/}
                </div>
                <div className="template-creator-info template-creator-info-select">
                  This choice defined if reports created with this template will
                  have table format or detailed format
                </div>
              </div>
            </React.Fragment>
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "10px"
            }}
          >
            <FlatButton label="Cancel" onClick={this.onClose} />
            <FlatButton label={title} onClick={onConfirm} />
          </div>
        </Dialog>
        <FlatButton
          label="Add New Template"
          onClick={() => {
            this.setState({ isOpen: true });
          }}
          labelStyle={{ color: "#fff" }}
          hoverColor={"#77c723"}
          backgroundColor={"#6da92e"}
          style={{
            marginBottom: "25px",
            position: "fixed",
            top: 20,
            right: 50,
            zIndex: 1300
          }}
        />
        <TemplateUploader  />
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps)(TemplateCreator);
